// 한국 지명
// 검색 0건 폴백 지명 사전의 kr 항목. 규약·운영 규칙은 ./index.ts 헤더 참고.
import type { SearchPlace } from "./index";

export const KR_PLACES: SearchPlace[] = [
  {
    id: "KR-SEL-SEONGSU",
    cityId: "KR-SEL",
    names: [
      "성수", "성수동", "seongsu", "seongsu-dong", "seongsudong",
      "聖水", "聖水洞", "圣水", "圣水洞", "ソンス", "ソンスドン",
    ],
    coordinates: { latitude: 37.5446, longitude: 127.0559 },
  },
  {
    id: "KR-SEL-APGUJEONG",
    cityId: "KR-SEL",
    names: [
      "압구정", "압구정동", "압구정로데오", "apgujeong", "apgujeong-rodeo",
      "狎鷗亭", "狎鸥亭", "アックジョン", "アプクジョン",
    ],
    coordinates: { latitude: 37.527, longitude: 127.0286 },
  },
  {
    id: "KR-SEL-DONGDAEMUN",
    cityId: "KR-SEL",
    names: [
      "동대문", "ddp", "디디피", "동대문디자인플라자", "dongdaemun",
      "東大門", "东大门", "トンデムン",
    ],
    coordinates: { latitude: 37.5665, longitude: 127.0092 },
  },
  {
    id: "KR-SEL-KONKUK",
    cityId: "KR-SEL",
    names: [
      "건대", "건대입구", "konkuk", "konkuk-univ", "건국대",
      "建大", "建大入口", "コンデ", "コンデイプク",
    ],
    coordinates: { latitude: 37.5404, longitude: 127.0694 },
  },
  {
    id: "KR-SEL-GIMPO-AIRPORT",
    cityId: "KR-SEL",
    names: [
      "김포공항", "김포", "gimpo", "gimpo-airport", "gmp",
      "金浦空港", "金浦机场", "金浦機場", "キンポ空港", "金浦",
    ],
    coordinates: { latitude: 37.5583, longitude: 126.7906 },
  },
  {
    id: "KR-SEL-SEOUL-STATION",
    cityId: "KR-SEL",
    names: [
      "서울역", "seoul-station", "seoulstation",
      "ソウル駅", "首爾站", "首尔站",
    ],
    coordinates: { latitude: 37.5547, longitude: 126.9707 },
  },
  {
    id: "KR-SEL-EULJIRO",
    cityId: "KR-SEL",
    names: [
      "을지로", "euljiro", "을지로입구",
      "乙支路", "ウルチロ",
    ],
    coordinates: { latitude: 37.566, longitude: 126.991 },
  },
  {
    id: "KR-SEL-DAEHAKRO",
    cityId: "KR-SEL",
    names: [
      "대학로", "혜화", "daehakro", "hyehwa",
      "大学路", "大學路", "テハンノ",
    ],
    coordinates: { latitude: 37.5822, longitude: 127.002 },
  },
  {
    id: "KR-SEL-COEX",
    cityId: "KR-SEL",
    names: [
      "코엑스", "coex", "삼성동", "samseong", "samseong-dong",
      "三成洞", "コエックス",
    ],
    coordinates: { latitude: 37.5115, longitude: 127.0595 },
  },
  {
    id: "KR-SEL-WANGSIMNI",
    cityId: "KR-SEL",
    names: ["왕십리", "wangsimni", "往十里", "ワンシムニ"],
    coordinates: { latitude: 37.5613, longitude: 127.0374 },
  },
  {
    id: "KR-SEL-SADANG",
    cityId: "KR-SEL",
    names: ["사당", "sadang", "舍堂", "サダン"],
    coordinates: { latitude: 37.4766, longitude: 126.9816 },
  },
  {
    id: "KR-SEL-SINLIM",
    cityId: "KR-SEL",
    names: ["신림", "sillim", "sinlim", "新林", "シルリム"],
    coordinates: { latitude: 37.4842, longitude: 126.9296 },
  },
  {
    id: "KR-SEL-MOKDONG",
    cityId: "KR-SEL",
    names: ["목동", "mokdong", "木洞", "モクドン"],
    coordinates: { latitude: 37.5265, longitude: 126.8756 },
  },
  {
    id: "KR-SEL-NOWON",
    cityId: "KR-SEL",
    names: ["노원", "nowon", "蘆原", "芦原", "ノウォン"],
    coordinates: { latitude: 37.6542, longitude: 127.0568 },
  },
  {
    id: "KR-ICN-SONGDO",
    cityId: "KR-ICN",
    names: [
      "송도", "songdo", "송도국제도시",
      "松島", "松岛", "ソンド",
    ],
    coordinates: { latitude: 37.3826, longitude: 126.656 },
  },
  {
    id: "KR-ICN-BUPYEONG",
    cityId: "KR-ICN",
    names: ["부평", "bupyeong", "富平", "プピョン"],
    coordinates: { latitude: 37.4894, longitude: 126.7247 },
  },
  {
    id: "KR-ICN-WOLMIDO",
    cityId: "KR-ICN",
    names: ["월미도", "wolmido", "月尾島", "月尾岛", "ウォルミド"],
    coordinates: { latitude: 37.4726, longitude: 126.5975 },
  },
  {
    id: "KR-PUS-GIMHAE-AIRPORT",
    cityId: "KR-PUS",
    names: [
      "김해공항", "gimhae-airport", "pus", "김해국제공항",
      "金海空港", "金海机场", "金海機場",
    ],
    coordinates: { latitude: 35.1795, longitude: 128.9382 },
  },
  {
    id: "KR-PUS-BUSAN-STATION",
    cityId: "KR-PUS",
    names: ["부산역", "busan-station", "釜山駅", "釜山站"],
    coordinates: { latitude: 35.115, longitude: 129.0413 },
  },
  {
    id: "KR-PUS-CENTUM",
    cityId: "KR-PUS",
    names: ["센텀", "센텀시티", "centum", "centum-city", "センタムシティ"],
    coordinates: { latitude: 35.1691, longitude: 129.13 },
  },
  {
    id: "KR-PUS-TAEJONGDAE",
    cityId: "KR-PUS",
    names: ["태종대", "taejongdae", "太宗台", "テジョンデ"],
    coordinates: { latitude: 35.0537, longitude: 129.0873 },
  },
  {
    id: "KR-JEJ-AIRPORT",
    cityId: "KR-JEJ",
    names: [
      "제주공항", "cju", "jeju-airport", "제주국제공항",
      "済州空港", "济州机场", "濟州機場",
    ],
    coordinates: { latitude: 33.5113, longitude: 126.493 },
  },
  {
    // 제주시에서 ~38km(섬 반대편). 도시 중심과 멀지만 제주 소속이 맞다.
    id: "KR-JEJ-SEONGSAN",
    cityId: "KR-JEJ",
    names: [
      "성산", "성산일출봉", "seongsan", "seongsan-ilchulbong",
      "城山", "城山日出峰", "ソンサン",
    ],
    coordinates: { latitude: 33.458, longitude: 126.9425 },
  },
  {
    id: "KR-JEJ-JUNGMUN",
    cityId: "KR-JEJ",
    names: ["중문", "jungmun", "中文", "チュンムン"],
    coordinates: { latitude: 33.2496, longitude: 126.412 },
  },
  {
    id: "KR-GYG-ILSAN",
    cityId: "KR-GYG",
    names: ["일산", "ilsan", "一山", "イルサン"],
    coordinates: { latitude: 37.6584, longitude: 126.77 },
  },
  {
    id: "KR-DGU-DONGSEONGRO",
    cityId: "KR-DGU",
    names: ["동성로", "dongseongro", "東城路", "东城路"],
    coordinates: { latitude: 35.8693, longitude: 128.5955 },
  },
  {
    id: "KR-DJN-DUNSAN",
    cityId: "KR-DJN",
    names: ["둔산", "dunsan", "屯山"],
    coordinates: { latitude: 36.352, longitude: 127.378 },
  },
  {
    id: "KR-GWJ-CHUNGJANGRO",
    cityId: "KR-GWJ",
    names: ["충장로", "chungjangro", "忠壯路", "忠壮路"],
    coordinates: { latitude: 35.149, longitude: 126.916 },
  },
  {
    // 수원 최근접 (13km)
    id: "KR-SEONGNAM",
    cityId: "KR-SWN",
    names: ["성남", "seongnam", "城南"],
    coordinates: { latitude: 37.3595, longitude: 127.1052 },
  },
  {
    // 수원 최근접 (15km)
    id: "KR-BUNDANG",
    cityId: "KR-SWN",
    names: ["분당", "bundang", "盆唐"],
    coordinates: { latitude: 37.3826, longitude: 127.1189 },
  },
  {
    // 고양 최근접 (8km)
    id: "KR-KINTEX",
    cityId: "KR-GYG",
    names: ["킨텍스", "kintex"],
    coordinates: { latitude: 37.6683, longitude: 126.746 },
  },
  {
    // 수원 최근접 (13km)
    id: "KR-YONGIN",
    cityId: "KR-SWN",
    names: ["용인", "yongin", "龍仁"],
    coordinates: { latitude: 37.2411, longitude: 127.1776 },
  },
  {
    // 수원 최근접 (16km)
    id: "KR-EVERLAND",
    cityId: "KR-SWN",
    names: ["에버랜드", "everland"],
    coordinates: { latitude: 37.2941, longitude: 127.202 },
  },
  {
    // 수원 최근접 (19km)
    id: "KR-HWASEONG",
    cityId: "KR-SWN",
    names: ["화성", "hwaseong"],
    coordinates: { latitude: 37.1996, longitude: 126.831 },
  },
  {
    // 수원 최근접 (16km)
    id: "KR-ANYANG",
    cityId: "KR-SWN",
    names: ["안양", "anyang", "安養"],
    coordinates: { latitude: 37.3943, longitude: 126.9568 },
  },
  {
    // 인천 최근접 (8km)
    id: "KR-BUCHEON",
    cityId: "KR-ICN",
    names: ["부천", "bucheon", "富川"],
    coordinates: { latitude: 37.5035, longitude: 126.766 },
  },
  {
    // 고양 최근접 (12km)
    id: "KR-PAJU",
    cityId: "KR-GYG",
    names: ["파주", "paju", "坡州"],
    coordinates: { latitude: 37.7599, longitude: 126.78 },
  },
  {
    // 광주 최근접 (57km)
    id: "KR-MOKPO",
    cityId: "KR-GWJ",
    names: ["목포", "mokpo", "木浦"],
    coordinates: { latitude: 34.8118, longitude: 126.3922 },
  },
  {
    // 대전 최근접 (72km)
    id: "KR-GUNSAN",
    cityId: "KR-DJN",
    names: ["군산", "gunsan", "群山"],
    coordinates: { latitude: 35.9676, longitude: 126.737 },
  },
  {
    // 부산 최근접 (18km)
    id: "KR-GIMHAE",
    cityId: "KR-PUS",
    names: ["김해", "gimhae"],
    coordinates: { latitude: 35.2285, longitude: 128.8894 },
  },
  {
    // 부산 최근접 (36km)
    id: "KR-CHANGWON",
    cityId: "KR-PUS",
    names: ["창원", "changwon", "昌原"],
    coordinates: { latitude: 35.228, longitude: 128.6811 },
  },
  {
    // 대전 최근접 (17km)
    id: "KR-SEJONG",
    cityId: "KR-DJN",
    names: ["세종", "sejong", "世宗"],
    coordinates: { latitude: 36.48, longitude: 127.289 },
  },
  {
    // 대전 최근접 (34km)
    id: "KR-CHEONGJU",
    cityId: "KR-DJN",
    names: ["청주", "cheongju", "淸州"],
    coordinates: { latitude: 36.6424, longitude: 127.489 },
  },
  {
    // 수원 최근접 (50km)
    id: "KR-CHEONAN",
    cityId: "KR-SWN",
    names: ["천안", "cheonan", "天安"],
    coordinates: { latitude: 36.8151, longitude: 127.1139 },
  },
  {
    // 대전 최근접 (62km)
    id: "KR-JEONJU",
    cityId: "KR-DJN",
    names: ["전주", "jeonju", "全州"],
    coordinates: { latitude: 35.8242, longitude: 127.148 },
  },
  {
    // 광주 최근접 (22km)
    id: "KR-DAMYANG",
    cityId: "KR-GWJ",
    names: ["담양", "damyang"],
    coordinates: { latitude: 35.3211, longitude: 126.9881 },
  },
  {
    // 광주 최근접 (48km)
    id: "KR-BOSEONG",
    cityId: "KR-GWJ",
    names: ["보성", "boseong"],
    coordinates: { latitude: 34.7714, longitude: 127.08 },
  },
  {
    // 광주 최근접 (101km)
    id: "KR-NAMHAE",
    cityId: "KR-GWJ",
    names: ["남해", "namhae"],
    coordinates: { latitude: 34.8376, longitude: 127.8925 },
  },
  {
    // 수원 최근접 (145km)
    id: "KR-JEONGSEON",
    cityId: "KR-SWN",
    names: ["정선", "jeongseon"],
    coordinates: { latitude: 37.3805, longitude: 128.6608 },
  },
  {
    // 서울 최근접 (46km)
    id: "KR-YANGPYEONG",
    cityId: "KR-SEL",
    names: ["양평", "yangpyeong"],
    coordinates: { latitude: 37.4917, longitude: 127.4876 },
  },
  {
    // 서울 최근접 (119km)
    id: "KR-INJE",
    cityId: "KR-SEL",
    names: ["인제", "inje"],
    coordinates: { latitude: 38.0697, longitude: 128.1706 },
  },
  {
    // 최근접은 인천공항(80km)이나 공항은 지역 라벨로 부적절 → 인천(87km, 사실상 동률)
    id: "KR-TAEAN",
    cityId: "KR-ICN",
    names: ["태안", "taean"],
    coordinates: { latitude: 36.7456, longitude: 126.298 },
  },
  {
    // 대전 최근접 (43km)
    id: "KR-BUYEO",
    cityId: "KR-DJN",
    names: ["부여", "buyeo", "扶餘"],
    coordinates: { latitude: 36.2757, longitude: 126.9098 },
  },
  {
    // 대전 최근접 (26km)
    id: "KR-GONGJU",
    cityId: "KR-DJN",
    names: ["공주", "gongju", "公州"],
    coordinates: { latitude: 36.4465, longitude: 127.119 },
  },
  {
    // 수원 최근접 (74km)
    id: "KR-SEOSAN",
    cityId: "KR-SWN",
    names: ["서산", "seosan"],
    coordinates: { latitude: 36.7848, longitude: 126.4503 },
  },
  {
    // 수원 최근접 (79km)
    id: "KR-WONJU",
    cityId: "KR-SWN",
    names: ["원주", "wonju", "原州"],
    coordinates: { latitude: 37.3422, longitude: 127.9202 },
  },
  {
    // 수원 최근접 (85km)
    id: "KR-CHUNGJU",
    cityId: "KR-SWN",
    names: ["충주", "chungju"],
    coordinates: { latitude: 36.991, longitude: 127.926 },
  },
];
